import { render, staticRenderFns } from "./PremiumBreakup.vue?vue&type=template&id=25682f90&scoped=true&lang=pug&"
import script from "./PremiumBreakup.vue?vue&type=script&lang=js&"
export * from "./PremiumBreakup.vue?vue&type=script&lang=js&"
import style0 from "./PremiumBreakup.vue?vue&type=style&index=0&id=25682f90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25682f90",
  null
  
)

export default component.exports